"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _SortArrow = _interopRequireDefault(require("./SortArrow"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TableHead = function TableHead(_ref) {
  var cols = _ref.cols,
      withCheckbox = _ref.withCheckbox,
      sortType = _ref.sortType,
      sortColumn = _ref.sortColumn,
      selected = _ref.selected,
      selectAllRows = _ref.selectAllRows,
      sortBy = _ref.sortBy;
  return _react.default.createElement("thead", null, _react.default.createElement("tr", null, withCheckbox && _react.default.createElement("th", {
    className: "data-table__col data-table__col--checkbox"
  }, _react.default.createElement(_Checkbox.default, {
    onChange: selectAllRows,
    checked: selected
  })), cols.map(function (col, index) {
    return _react.default.createElement("th", {
      className: "data-table__col",
      key: index,
      onClick: function onClick() {
        return sortBy(col.id);
      }
    }, _react.default.createElement("span", null, col.title), col.id && _react.default.createElement(_SortArrow.default, {
      id: col.id,
      sortType: sortType,
      sortColumn: sortColumn
    }));
  })));
};

TableHead.propTypes = {
  cols: _propTypes.default.array,
  withCheckbox: _propTypes.default.bool,
  seleted: _propTypes.default.bool,
  sortType: _propTypes.default.string,
  sortColumn: _propTypes.default.string,
  sortBy: _propTypes.default.func,
  selectAllRows: _propTypes.default.func
};
var _default = TableHead;
exports.default = _default;